export default __webpack_public_path__ + "static/media/audio_36_cepillado_de_dientes.636d178e.mp3";